import { css } from "@emotion/react";

import { fontSize } from "~/client/styles/emotion/mixins/fontSize";

export const memberCss = css({
  display: "grid",
  gridTemplateColumns: "min-content auto",
  columnGap: "8px",
  alignItems: "center",
  wordBreak: "break-word",
});

export const realNameCss = css({
  lineHeight: 1,
});

export const accountCss = css({
  ...fontSize(12),
});
